import React from 'react';
import App from './src/App';

import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';
const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
      </Routes>
    </BrowserRouter>
  );
} else {
  console.error("Target container 'app' not found in HTML");
}
